import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type IncidentId = Brand<string, 'incidentId'>;

export const INCIDENT_SCHEMA: z.ZodType<IIncident> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as IncidentId)
    .optional(),
  code: z.string(),
  createdAt: z.iso.datetime().optional(),
});

export const INCIDENTS_SCHEMA: z.ZodType<IIncident[]> =
  z.array(INCIDENT_SCHEMA);

export interface IIncident {
  id?: IncidentId;
  code: string;
  createdAt?: string;
}
